import { EnumTipoDataControle } from "../enums/EnumDataControle";
import { BaseObj } from "./UserdataSync";

export class DataControle extends BaseObj {
  tipo: EnumTipoDataControle;
  data: Date;
}
